module.exports = __webpack_public_path__ + "03d3aa84f56b6bf404a9880694277a9b.png";